<template>
  <VersionSelect v-if="plp_task_id" fluid>
    <template #content="{ data, readonly, onChange, onBlur, onCreate }">
      <TaLpData
        :value="data"
        :readonly="readonly"
        :onCreate="onCreate"
        @change="onChange"
        @blur="onBlur"
      />
    </template>
  </VersionSelect>
</template>

<script>
import { mapGetters } from 'vuex'
import VersionSelect from '@/components/VersionSelect'
import TaLpData from '@/components/expAnalogs/taLp/TaLpData'

export default {
  components: { VersionSelect, TaLpData },
  computed: {
    ...mapGetters(['plp_task_id']),
  },
}
</script>

<style scoped>
.container {
  width: 100%;
}
</style>
